import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "search-bar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["TheSearchBar"], {
      show: $setup.showSearchBar,
      queryParamName: $setup.searchQueryParamName
    }, null, 8 /* PROPS */, ["show", "queryParamName"])
  ]))
}